import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ChangeCurrency } from '../../utils/statics';

const imageStyle = css`
  height: 24px;
  width: 24px;
  background-color: transparent;
  background-image: url(${ChangeCurrency});
  background-size: auto;
  color: transparent !important;
  -webkit-appearance: none;
  appearance: none;
  border-color: transparent;
`;

const SelectBg = styled('select')`
  ${imageStyle},
`;

const IconSelect = ({ items, onChange, current }) => {
  const onSelected = event => {
    const { value: selectedValue } = event.target;
    onChange(selectedValue);
  };
  return (
    <SelectBg onChange={onSelected} value={current} disableUnderline>
      {items.map((item, index) => (
        <option key={index} value={item}>
          {item}
        </option>
      ))}
    </SelectBg>
  );
};

IconSelect.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  current: PropTypes.string,
};

export default IconSelect;
